import React, { useMemo } from "react";
import { withTranslation } from "react-i18next";
import { Col, Row } from "reactstrap";
import PropTypes from "prop-types";
import { get } from "lodash";

import Collapse from "./Collapse";
import { getOptionLabel } from "common/enums";

const MeterRequisitionView = ({ dcsDemand, isExpandable = true, t }) => {
  const { chilledWaterLineDiameterUnit, waterFlowRateUnit } = dcsDemand;
  const fields = useMemo(
    () => [
      {
        name: "Chilled Water Line Diameter",
        key: "chilledWaterLineDiameter",
        renderField: (value) =>
          value
            ? `${value} ${getOptionLabel(
                "unitOptions",
                chilledWaterLineDiameterUnit
              )}`
            : "N/A",
        isRequired: true,
      },
      {
        name: "Water Flow Rate",
        key: "waterFlowRate",
        renderField: (value) =>
          value
            ? `${value} ${getOptionLabel("unitOptions", waterFlowRateUnit)}`
            : "N/A",
        isRequired: true,
      },
    ],
    [dcsDemand]
  );

  return (
    <Collapse title="Meter Requisition Details" isExpandable={isExpandable}>
      <Row className="d-flex mb-2">
        {fields.map(({ name, key, isRequired, renderField }) => {
          const value = get(dcsDemand, key, "");

          return (
            <Col key={key} lg={6} className="mb-1">
              <Row>
                <Col md={5}>{t(name)}:</Col>
                <Col
                  md={7}
                  className="fw-semibold"
                  style={{ wordBreak: "break-word" }}
                >
                  {renderField
                    ? renderField(value)
                    : get(dcsDemand, key, null) ?? (isRequired ? "-" : "N/A")}
                </Col>
              </Row>
            </Col>
          );
        })}
      </Row>
    </Collapse>
  );
};

MeterRequisitionView.propTypes = {
  isExpandable: PropTypes.bool,
  dcsDemand: PropTypes.object,
  t: PropTypes.func,
};

export default withTranslation()(MeterRequisitionView);
